import React, { ForwardedRef } from 'react';
import clsx from 'clsx';
import styles from '@danske/sapphire-css/components/table/table.module.css';
import { useTableContainerContext } from './TableContainerContext';
import { SapphireStyleProps, useSapphireStyleProps } from '../../utils';
import { mergeProps } from '@react-aria/utils';

export interface TableFooterProps extends SapphireStyleProps {
  // TODO extend more
  /**
   * Note: Currently, only native HTML table elements are supported.
   * The styles are designed with the assumption
   * that the CSS `display` property is set to `table-header-group`.
   * TODO: Update CSS styles to accommodate other element types.
   *
   * @default 'tfoot'
   */
  elementType?: 'tfoot' | 'div';
  children?: React.ReactNode;
}

export const TableFooter = React.forwardRef(function TableFooter(
  { children, elementType = 'tfoot', ...props }: TableFooterProps,
  ref: ForwardedRef<HTMLTableSectionElement>
) {
  const ElementType = elementType;
  const context = useTableContainerContext();
  const shouldFooterStick = context?.shouldHeaderStick || false;
  const { styleProps, filteredProps } = useSapphireStyleProps(props);

  return (
    <ElementType
      ref={ref}
      {...mergeProps(filteredProps, { role: 'rowgroup' })}
      className={clsx(
        styles['sapphire-table__tfoot'],
        styleProps.className,
        {
          [styles['sapphire-table__footer--sticky']]: shouldFooterStick,
        },
        styleProps.className
      )}
      style={styleProps.style}
    >
      {children}
    </ElementType>
  );
});
